/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'pool-group';
const componentName = 'pool-group-list-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const numberOfPoolsLabel = `${prefix}.numberOfPoolsLabel`;
export const poolNotUsedLabel = `${prefix}.poolNotUsedLabel`;

export const ENGLISH = {
    [headerLabel]: 'Pool Groups',
    [numberOfPoolsLabel]: 'Number of Pools',
    [poolNotUsedLabel]: 'Pool is not used by any VS',
};
